import React, { useState, useEffect } from 'react';

import CheckInOutButtonDiv from '../Dashboard/components/CheckInOutButtonDiv/CheckInOutButtonDiv';
import CheckInInfo from '../Dashboard/components/CheckInInfo/CheckInInfo';
import classes from './../Dashboard/Dashboard.module.scss';
import Tabs from '../Dashboard/components/Tabs/Tabs';
import { useOutletContext } from "react-router-dom";

const Home = () => {
    const [isAttendance, setIsAttendance] = useState(null);
    const modules = JSON.parse(localStorage.getItem('modules'));
    const [isModules , setIsModules] = useState([])
   
    useEffect(()=>{
        
        if(modules !== null || modules===""){
            setIsModules(modules)
            if(modules.includes("ATTENDANCE")){
                setIsAttendance(true);
            }else{
                setIsAttendance(false);
            }
        }
    },[isAttendance])

    return (
        <>
            {isAttendance ? <CheckInInfo /> :  <div className={classes.Spacer}></div>}
            <div className={classes.ActionsDiv}>

                {/* Check In Out Buttons  */}
            {isAttendance ? <CheckInOutButtonDiv /> :  <div className={classes.Spacer}><h1>CANTEEN APP</h1></div>}

                
                <div className={classes.TabsDiv}>
                    <Tabs modules={isModules}/>
                </div>
            </div>
        </>
    )
}

export default Home

